// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__3beqU","title":"AfterImages90_title__1USVd","images":"AfterImages90_images__2fBs0"};